import { debounce } from './utils';

type CallbackFunctionVariadic = (...args: any[]) => void;

export function resizeObserver(el: Element, callback: CallbackFunctionVariadic, useDebounce = true) {
  let observerCallback: CallbackFunctionVariadic = callback;
  if (useDebounce) {
    observerCallback = debounce(callback, 100);
  }
  const observer = new ResizeObserver((entries) => {
    observerCallback(entries);
  });

  observer.observe(el);

  return () => observer.unobserve(el);
}
